export const environment = {
	production: true,
	apiUrl: '/api'
	// apiUrl: 'http://192.168.1.73:3000/api',
}
